// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10fL4","right":"styles_right__3T6yR"};